// in src/posts.js
import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, TextInput, Button, TopToolbar, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, useUpdate, useNotify, BooleanField, BooleanInput } from 'react-admin';import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';



import EditIcon from '@material-ui/icons/Edit';
import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import Box from '@material-ui/core/Box';


import { validateMaxLength } from './../components/Validator';export const SettingsTicketsValidators = (props) => {
  const translate = useTranslate();    
    
  let strRedirect =  '/settings-tickets-validators';  
    
  return (
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('tickets_validators.title')}              
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
        <ResourceContextProvider value="tickets_validators">
          <List {...props} 
            basePath="/tickets_validators" 
            sort={{ field: 'id', order: 'DESC' }} 
            actions={<ListActionsTicketsValidatorsList/>}    
            filter={{ associations_id : localStorage.getItem('associations_id') }}  
            bulkActionButtons={false}  
            pagination={false}
            empty={<ListActionsTicketsValidatorsList />} 
            fullWidth
          >        
            <Datagrid fullWidth>            
              <TextField source="name" label={translate('tickets_validators.name')} sortable={false} />  
              <TextField source="email" label={translate('tickets_validators.email')} sortable={false}  />              
              <BooleanField source="apply_default" label={translate('tickets_validators.apply_default')} sortable={false}  />              
              <TicketsValidatorsEditButton label="" />
              <DeleteButton undoable={false} redirect={strRedirect} label="" />
            </Datagrid>        
          </List>
        </ResourceContextProvider>
      </Box>
    </>
  );
};

const ListActionsTicketsValidatorsList = (props) => {
  const translate = useTranslate(); 
  return (
    <TopToolbar>     
      <TicketsValidatorsCreateButton />      
    </TopToolbar>
  );
};


const TicketsValidatorsCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [create, { loading }] = useCreate('tickets_validators');

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };    

  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_validators.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_validators.create')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_validators.create')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_validators"
          save={handleSubmit}
          initialValues={ { associations_id : localStorage.getItem('associations_id'), permission_validate: true, permission_unvalidate: true, permission_booking_data: true, permission_custom_fields: true, permission_statistics: true  } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const FormContent = (props) => {

  const translate = useTranslate(); 
  return (
    <DialogContent>
        <Grid container spacing={2}>
            <Grid item xs={6}>   
                <TextInput fullWidth source="name" label={translate('tickets_validators.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
            </Grid> 
            <Grid item xs={6}>   
                <TextInput fullWidth source="email" label={translate('tickets_validators.email')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
            </Grid> 
            <Grid item xs={12}>   
                <BooleanInput fullWidth source="apply_default" label={translate('tickets_validators.apply_default')} />
            </Grid> 
            <Grid item xs={12}>   
                <Typography variant="h6" className="grey8 titleUserShow">                        
                    {translate('tickets_validators.permissions_default_title')}
                </Typography>
            </Grid> 
            <Grid item xs={6}>   
                <BooleanInput fullWidth source="permission_validate" label={translate('tickets_validators.permission_validate')} />
            </Grid> 
            <Grid item xs={6}>   
                <BooleanInput fullWidth source="permission_unvalidate" label={translate('tickets_validators.permission_unvalidate')} />
            </Grid> 
            <Grid item xs={6}>   
                <BooleanInput fullWidth source="permission_booking_data" label={translate('tickets_validators.permission_booking_data')} />
            </Grid> 
            <Grid item xs={6}>   
                <BooleanInput fullWidth source="permission_custom_fields" label={translate('tickets_validators.permission_custom_fields')} />
            </Grid> 
            <Grid item xs={6}>   
                <BooleanInput fullWidth source="permission_statistics" label={translate('tickets_validators.permission_statistics')} />
            </Grid> 
        </Grid>           
    </DialogContent>
  );
};

const TicketsValidatorsEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'tickets_validators', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_validators.edit')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_validators.edit')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_validators"
          save={handleSubmit}
          initialValues={ props.record }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

